// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"d57a0418","601":"0a34ed86","878":"62d9cdbb"}[chunkId] + ".chunk.css";
};